export const MAP_SCALE = 0.8;

// Room dimensions
export const ROOM_WIDTH = 30;
export const ROOM_LENGTH = 40;
export const ROOM_HEIGHT = 13;

export const FLOOR_DIMENSIONS: [number, number] = [ROOM_WIDTH, ROOM_LENGTH];

export const WALL_WIDTH = Math.max(ROOM_WIDTH, ROOM_LENGTH) * 1.5;
export const WALL_HEIGHT = ROOM_HEIGHT;
export const WALL_DEPTH = 0.5 * MAP_SCALE;
export const WALL_DIMENSIONS: [number, number, number] = [WALL_WIDTH, WALL_HEIGHT, WALL_DEPTH];
export const WALL_POSITION_Y = WALL_HEIGHT / 2;
export const WALL_OFFSET_X = FLOOR_DIMENSIONS[0] / 2;
export const WALL_OFFSET_Z = FLOOR_DIMENSIONS[1] / 2;

export const ROOF_SIZE: [number, number] = FLOOR_DIMENSIONS;
export const ROOF_HEIGHT = WALL_HEIGHT;

export const MEZZANINE_Y = 7;
